import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import BarChart from "../../../../Components/BarChart";
// import LineChart from "../../Components/LineChart";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../../App";
import {API_URL, getAuthHeaders, getUserClaimsForUi}  from '../../../../Constant';


function UrbanConsumerRetailPriceGraph() {
   
    const [years,setYears]=useState([]);
    const [yearName,setyearName]=useState('');
    const [months,setMonth]=useState([]);
    const [monthName,setMonthName]=useState('');
    const [groups,setGroups]=useState([]);
    const [groupName,setGroupName]=useState('');
    const [groupId,setGroupId]=useState('');
    const [chart,setChart]=useState('bar_chart');
    const [sectorCode,setSectorCode]=useState('');
    const [UrbanConsumerData,setUrbanConsumerData]=useState('');
   const shortMonthToFull=(shortMonth)=> {
    const monthMapping = {
        JAN: 'January',
        FEB: 'February',
        MAR: 'March',
        APR: 'April',
        MAY: 'May',
        JUN: 'June',
        JUL: 'July',
        AUG: 'August',
        SEP: 'September',
        OCT: 'October',
        NOV: 'November',
        DEC: 'December',
      };
      return monthMapping[shortMonth] || null; 
    }
   



    
    // const config = {
    //   headers: {
    //       Authorization: `Bearer ${useContext(MyContextProvider).token}`,
    //   },
    // };
    const decode_token = getUserClaimsForUi();
    const token = decode_token;
    const config = getAuthHeaders();
    




    useEffect(() => { //Get all Years Data
        //Years
        showLoading(true)
      axios
        .get(`${API_URL}api/graph/getYears`,config)
        .then((res) => {
          let yearDataResponse=res.data;
          if(yearDataResponse.status){
             setYears(yearDataResponse.data);
             showLoading(false)
            }
       }).catch((err) => console.log(err));
      
       //Group Name
        axios
        .get(`${API_URL}api/graph/getGroup`,config)
        .then((res) => {
          let groupDataResponse=res.data;
          if(groupDataResponse.status){
              setGroups(groupDataResponse.data);
           }
       })
        .catch((err) => console.log(err));

    }, []);
     
    const yearOnChange =(e)=>{ //Get all Months data
     
      setyearName(e.target.value);
      if(e.target.value===''){
        return false;
      }
         showLoading(true)
         setMonthName('');
        axios
           .get(`${API_URL}api/graph/getMonths/${e.target.value}`,config) //${process.env.REACT_APP_API_URL}
           .then((res) => {
             let monthDataResponse=res.data;
             if(monthDataResponse.status){
                 setMonth(monthDataResponse.data);
                 showLoading(false)
               }
          })
           .catch((err) => console.log(err));
     }

  const onChangeGroupName=(e)=>{

    const selectedOption = e.target.options[e.target.selectedIndex];
    const id = selectedOption.value;
    const name = selectedOption.textContent;
 
    if(id==="801"){
      setSectorCode("10")
     }else{
      setSectorCode("1")
     }
    setGroupName(name)
    setGroupId(id)

  }   


const handleSubmit=(e)=>{
  
      if(yearName===''){
        toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
        return;
      }

      if(monthName===''){
        toast.error(messages.MONTH_NAME_MSG, messages.COLOR_RED);
        return;
      }

      if(groupId===''){
        toast.error(messages.GROUP_NAME_MSG, messages.COLOR_RED);
        return;
      }
      
      showLoading(true) 
      
        axios
        .post(`${API_URL}api/graph/Usp_UrbanConsumerRetailPriceGraph`,{   
          year_name:yearName,
          month_name:monthName,
          group_name:groupName,
          group_id:groupId,
          chart:chart,
          sector_code:sectorCode
        },config) 
        .then((res) => {
          showLoading(false)
          if(res.data.status){
            setUrbanConsumerData(res.data.data)
            
          }
        }).catch((err)=>{
          showLoading(false)
          console.log(err)
        } );
        
}
  return (
    
    <>
      {/* Page Content Open */}
    <div className="container-fluid py-3">
       <ToastContainer />
       <GlobalLoading />
         {/* Search Filter Open */}
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
           <div className="row align-items-center">
            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">Year</label>
                <select value={yearName} onChange={yearOnChange} name="year_name"  className="form-select" >
                  <option value="">Select Year</option>
                   { years && years.map((ele,index)=>(
                     <option key={index} value={ele.CURRENT_YEAR}>{ele.CURRENT_YEAR}</option>
                   ))
                    }
 
                </select>
            </div>

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">Month</label>
                 <select value={monthName} onChange={(e)=>(setMonthName(e.target.value))} name="month_name" className="form-select">
                    <option value="">Select Month</option>
                    {months && months.map((ele,i)=>(
                     <option key={i} value={ele.MONTH}>{shortMonthToFull(ele.MONTH)}</option>
                    ))

                    }
                 </select>
             </div>

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">Group</label>
                <select value={groupId} onChange={onChangeGroupName} name="group_name" className="form-select ">
                   <option value="">Select Group</option>
                    { groups && groups.map((ele,i)=>(
                   <option key={i} value={ele.MAJOR_GROUP_CODE}>{ele.MAJOR_GROUP_NAME} </option>
                    ))
                    }
                 </select>
            </div>

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="w-100 mb-2 fw-bold h6">Chart Type</label>
                <div className="form-check form-check-inline me-2">
                    <input type="radio" onChange={(e)=>(setChart(e.target.value))} checked={chart==='bar_chart'} className="form-check-input" id="radio1" name="bar_chart" value="bar_chart" />
                    <label className="form-check-label" htmlFor="radio1">Bar Chart</label>
                </div>
                <div className="form-check form-check-inline">
                    <input type="radio" disabled   onChange={(e)=>(setChart(e.target.value))} checked={chart==='line_chart'} className="form-check-input" id="radio2" name="line_chart" value="line_chart"/>
                    <label className="form-check-label" htmlFor="radio2" >Line Chart</label>
                </div>
            </div>
            <div className="col-xl-4 col-lg-12 mb-3">
                
                <button type="submit" onClick={handleSubmit} className="btn btn_orange">Show</button>
                <button type="button" id="print" className="btn btn_gray ms-1">Print</button>
            </div>
          </div>
         </div>
        </div>
        {/* /Row */}
        {/* Search Filter Close */}
        {/*top 5 Items BarChart */}

        {/**********  Bar Chart **********/}
      { chart==='bar_chart' &&
        UrbanConsumerData &&  
          <BarChart graphData={UrbanConsumerData} shortMonthToFull={shortMonthToFull} chartDetails={{"chart_type":"Urban_Consumer_Chart"}} />
       
       }
   </div>

    </>
  )
}

export default UrbanConsumerRetailPriceGraph